/* Package JSON Import will be here */
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import queryString from "query-string";
/* Package JSON Import will be here */

/* Project Import will be here */
import { loginJnJ, loginNew } from "reducers/session";
import DirectLoginForm from "./DirectLoginForm";
import LoginVerification from "./LoginVerification";
import Constants from "utilities/appConstants";
import { showMsgFromJson } from "reducers/common";
import NewLoginFormContainer from "./newLogin/NewLoginFormContainer";
/* Project Import will be here */

class Login extends Component {
  componentDidMount() {
    const query = queryString.parse(this.props.location.search);

    if (query && query.mob) {
      /* If the mobile number length is 10 check for the user and login the user */
      /* Else will show the error message */
      if (query.mob.length === 10)
        return this.props.actions.loginNew({ loginId: query.mob, query: query });
      else
        this.props.actions.showMsgFromJson("session.error.mobileNumberLength", Constants.ERROR);
    }
  }

  /* Submitting the old login flow */
  onSubmit = (values) => {
    return this.props.actions.loginJnJ({ loginId: values.username, mobileNo: values.mobileNo, query: null });
  };

  renderLoginForm = () => {
    const query = queryString.parse(this.props.location.search);

    if (query && query.mob && query.mob.length === 10 && !this.props.session.userLoginAtFirstTime)
      return (<DirectLoginForm userName={query.mob} />);
    else
      return (<NewLoginFormContainer />);
  };

  render() {
    return (
      <React.Fragment>
        {this.renderLoginForm()}

        {/* OTP login confirmation modal */}
        {this.props.appSettings.otpAuthAfterLogin && <LoginVerification />}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    location: state.router.location,
    appSettings: state.appSettings,
    session: state.session
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(
      {
        loginJnJ,
        loginNew,
        showMsgFromJson
      },
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
